import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fab);

export default function Footer() {
  return (
    <footer className="border-t-4 border-[#f6f6f6] py-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          
          <div>
            <Link to="/" className="mb-3 inline-flex">
              <img
                src="/assets/images/LOGO2_Plan.png"
                alt="Sante Flex"
                className="h-20 w-20 rounded-lg"
                width="90"
              />
            </Link>
            <p className="text-sm text-gray-700">
              QUALITAS ASSURANCES se positionne comme un courtier innovant et dynamique sur le marché des assurances en Côte d’Ivoire...
            </p>
            <ul className="mt-3 space-y-2 text-sm text-gray-700">
              <li className="flex items-start">
                <FontAwesomeIcon icon={faLocationDot} className="me-2 mt-0.5 text-secondary" />
                <span>Cocody, Bonoumin Abidjan, Côte d'Ivoire</span>
              </li>
              <li className="flex items-start">
                <FontAwesomeIcon icon={faEnvelope} className="me-2 mt-0.5 text-secondary" />
                <a href="mailto:contact@qualitas-assurance.com" className="text-dark">contact@qualitas-assurance.com</a>
              </li>
              <li className="flex items-start">
                <FontAwesomeIcon icon={faPhone} className="me-2 mt-0.5 text-secondary" />
                <a href="tel:+2252722351964" className="text-dark">+225 27 22 351 964</a>
              </li>
            </ul>
          </div>

        
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h3 className="text-base font-bold text-gray-900">Entreprise</h3>
              <ul className="mt-3 space-y-3 text-sm text-gray-500">
                <li><a href="#" className="block hover:text-gray-700">À propos de nous</a></li>
                <li><a href="#" className="block hover:text-gray-700">Nos services</a></li>
                <li><a href="#" className="block hover:text-gray-700">Contact</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-base font-bold text-gray-900">Support</h3>
              <ul className="mt-3 space-y-3 text-sm text-gray-500">
                <li><a href="#" className="block hover:text-gray-700">FAQ</a></li>
                <li><a href="#" className="block hover:text-gray-700">Conditions Générales</a></li>
                <li><a href="#" className="block hover:text-gray-700">Politique de Confidentialité</a></li>
              </ul>
            </div>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900">S&apos;abonner à la newsletter</h3>
            <form className="mt-3 flex flex-col gap-2 sm:flex-row">
              <input
                type="email"
                placeholder="Entrez votre email"
                className="w-full rounded-xl border-2 border-[#B5B8B6] px-4 py-2 focus:border-primary focus:outline-none focus:ring-2 focus:ring-[#dd33332a]"
              />
              <button
                type="submit"
                className="rounded-md bg-secondary-dark px-4 py-2 text-sm font-medium text-white transition hover:bg-secondary"
              >
                S&apos;abonner
              </button>
            </form>
            <div className="mt-4 flex gap-2">
              <a href="https://www.linkedin.com/company/qualitas-assurances/" target="_blank" rel="noreferrer" className="rounded-md border border-primary p-2 text-primary hover:bg-primary hover:text-white">
                <FontAwesomeIcon icon={['fab', 'linkedin-in']} />
              </a>
              <a href="https://www.instagram.com/qualitas_assurances/" target="_blank" rel="noreferrer" className="rounded-md border border-primary p-2 text-primary hover:bg-primary hover:text-white">
                <FontAwesomeIcon icon={['fab', 'instagram']} />
              </a>
              <a href="https://www.facebook.com/people/QUALITAS-ASSURANCES/61562264944306/" target="_blank" rel="noreferrer" className="rounded-md border border-primary p-2 text-primary hover:bg-primary hover:text-white">
                <FontAwesomeIcon icon={['fab', 'facebook-f']} />
              </a>
            </div>
          </div>
        </div> */}

        <div className="text-center text-sm text-gray-600">
          © 2026 Santé Flex. All rights reserved - 
          By <a href="https://qualitas-assurance.com" target="_blank" rel="noreferrer" className="text-secondary">Qualitas Assurances</a>
        </div>
      </div>
    </footer>
  );
}